export default "__VITE_ASSET__CPdDGXjk__"